import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/store";

export interface auditReducerInterface {
  search: Nullable<string>;
  relation: Nullable<AuditRelationType>;
  logTypes: AuditLogType[];
  user: Nullable<SmallUser>;
  action: Nullable<AuditActionType>;
  start: Nullable<Date>;
  stop: Nullable<Date>;
}

const initialState: auditReducerInterface = {
  search: null,
  relation: null,
  logTypes: ["CUSTOMERS_PROJECTS", "USERS_RIGHTS", "COMMUNICATION", "SECRETS"],
  user: null,
  action: null,
  start: null,
  stop: null,
};

const auditSlice = createSlice({
  name: "admin/audit",
  initialState,
  reducers: {
    resetFilters(state) {
      state.search = null;
      state.relation = null;
      state.user = null;
      state.start = null;
      state.stop = null;
      state.action = null;
      state.logTypes = ["CUSTOMERS_PROJECTS", "USERS_RIGHTS", "COMMUNICATION", "SECRETS"];
    },
    setSearch(state, { payload }: PayloadAction<Nullable<string>>) {
      state.search = payload;
    },
    setRelation(state, action: PayloadAction<Nullable<AuditRelationType>>) {
      state.relation = action.payload;
    },
    setLogTypes(state, action: PayloadAction<AuditLogType[]>) {
      state.logTypes = action.payload;
    },
    setUser(state, { payload }: PayloadAction<Nullable<SmallUser>>) {
      state.user = payload;
    },
    setAction(state, action: PayloadAction<Nullable<AuditActionType>>) {
      state.action = action.payload;
    },
    setStart(state, { payload }: PayloadAction<Nullable<Date>>) {
      state.start = payload;
    },
    setStop(state, { payload }: PayloadAction<Nullable<Date>>) {
      state.stop = payload;
    },
  },
});

export const { setRelation, setUser, setAction, setStart, setStop, resetFilters, setSearch, setLogTypes } =
  auditSlice.actions;
export const auditSelector = (state: RootState) => state.audit;
export default auditSlice.reducer;
